(function() {
  'use strict';
  var VL_SVG_LOGO = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 44" width="200" height="36" style="display:block">'
    + '<path d="M22 3C22 3 36 9.5 36 22.5C36 30 30 36.5 22 38.5C14 36.5 8 30 8 22.5C8 9.5 22 3 22 3Z" fill="#5A6B4A" opacity="0.9"/>'
    + '<path d="M22 10.5C22 10.5 16 18.5 16 26" stroke="#3B4A3A" stroke-width="1.8" stroke-linecap="round" opacity="0.7"/>'
    + '<path d="M22 14.5C22 14.5 26.5 20.5 26.5 26" stroke="#3B4A3A" stroke-width="1.2" stroke-linecap="round" opacity="0.5"/>'
    + '<path d="M22 18.5C22 18.5 18.5 22.5 18.5 28" stroke="#3B4A3A" stroke-width="1" stroke-linecap="round" opacity="0.4"/>'
    + '<text x="48" y="29" font-family="system-ui,-apple-system,Segoe UI,Roboto,sans-serif" font-size="26" letter-spacing="-0.5">'
    + '<tspan font-weight="600" fill="#3B4A3A">Vitamin</tspan>'
    + '<tspan font-weight="600" fill="#5A6B4A">Loft</tspan>'
    + '<tspan font-weight="400" font-size="15" fill="#5A6B4A" opacity="0.55">.com</tspan>'
    + '</text></svg>';
  function replaceLogo() {
    var logoLink = document.querySelector('a.logo');
    if (logoLink) {
      logoLink.innerHTML = VL_SVG_LOGO;
      logoLink.style.display = 'flex';
      logoLink.style.alignItems = 'center';
    }
  }
  function hideDawnFooterOnHomepage() {
    var isHomepage = window.location.pathname === '/';
    if (!isHomepage) return;
    var dawnFooter = document.querySelector('#shopify-section-sections--19863218978902__footer');
    if (dawnFooter) {
      dawnFooter.style.display = 'none';
    } else {
      var footer = document.querySelector('footer.footer');
      if (footer) {
        var section = footer.closest('.shopify-section');
        if (section) section.style.display = 'none';
        else footer.style.display = 'none';
      }
    }
  }
  function hidePromoBanners() {
    var promo = document.querySelector('.promo-bar-pro');
    if (promo) promo.style.display = 'none';
    var shipping = document.querySelector('.shipping-progress-bar');
    if (shipping) shipping.style.display = 'none';
  }
  function init() {
    replaceLogo();
    hideDawnFooterOnHomepage();
    hidePromoBanners();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();